
<h5 class="primary pt-2 pb-3">Stations</h5>

<ul class="fdm-sidebar-scene-layers" *ngIf="!loading">

  <li *ngFor="let cur of stations"  class="p-2">
    <a [routerLink]="[cur.annotationMode == 'PIN'?'poi':cur.annotationMode || 'poi',cur.id]" 
      (click)="mapService.helper.sendCameraTo(cur)"  [ngClass]="{'primary-bg-light':cur == mapComp?.inspectorComp?.selected}">
 
      <fa-icon color="primary" [icon]="'wifi'" [fixedWidth]="true"></fa-icon> {{ cur.name }}  </a>
    
  
  </li>
</ul>

<h5 class="primary pt-2 pb-3">Rovers</h5>

<ul class="fdm-sidebar-scene-layers" *ngIf="!loading">

  <li *ngFor="let cur of rovers"  class="p-2">
    <a [routerLink]="[cur.annotationMode == 'PIN'?'poi':cur.annotationMode || 'poi',cur.id]" 
      (click)="mapService.helper.sendCameraTo(cur)"  [ngClass]="{'primary-bg-light':cur == mapComp?.inspectorComp?.selected}">
 
      <fa-icon color="primary" [icon]="'crosshairs'" [fixedWidth]="true"></fa-icon> {{ cur.name }}  </a>
     
  
  </li>
</ul>

